import React from 'react';

import { Tooltip } from 'antd';
import { FilePdfOutlined } from '@ant-design/icons';

import { IToolbarCommand } from '../../../../../../../models/Shopping';

const CommandExportPdf: React.FunctionComponent<IToolbarCommand> = ({ disabled, action }) => {
    const _handleCommandAction = () => {
        if (disabled || !action) {
            return;
        }

        action();
    }

    return (
        <div className={`command ${disabled && 'command-disabled'}`} onClick={_handleCommandAction}>
            <Tooltip title={'Print order'}>
                <FilePdfOutlined />
            </Tooltip>
        </div>
    );
}

export default CommandExportPdf;